import { render, staticRenderFns } from "./OneGoods.vue?vue&type=template&id=04c189aa&scoped=true&"
import script from "./OneGoods.vue?vue&type=script&lang=js&"
export * from "./OneGoods.vue?vue&type=script&lang=js&"
import style0 from "./OneGoods.vue?vue&type=style&index=0&id=04c189aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c189aa",
  null
  
)

export default component.exports